export default "__VITE_ASSET__B6q1Xv9j__"